/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { BLoginService } from '../../service/bLogin.service';

@Injectable()
export class logingaurdService implements CanActivate {

  constructor(private bLoginService: BLoginService, private router: Router) { }

  canActivate() {
    if (!this.bLoginService.isLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/bhive']);
      return false;
    }
  }
}


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/loginGaurd/logingaurd.service.ts